import { fetchTodaysIncomingOrders, fetchIncomingOrdersByDate,  fetchPurchaseOrders, selectPurchaseOrder, resetCurrentPurchaseOrder } from '../../actions/purchaseOrders_actions';
import { fetchWarehouseBins, fetchWarehouses, fetchWarehouseSalesOrders, fetchWarehousePurchaseOrders } from '../../actions/warehouses_actions';
import { fetchTodaysOutgoingOrders, fetchOutgoingOrdersByDate } from '../../actions/sales_actions';
import { fetchInventories, selectInventory, resetCurrentInventory } from '../../actions/inventories_actions';
import { fetchFavorites, selectFavorites, resetCurrentFavorites, deleteFavorite } from '../../actions/favorites_actions';
import { connect } from 'react-redux';
import { reduxForm, formValueSelector } from 'redux-form';

import WarehouseDashboard from '../../components/Purchase/warehouseDashboard';

let warehouseDashboard = reduxForm({
    form: 'warehouseDashboard',
})(WarehouseDashboard);

const selector = formValueSelector('warehouseDashboard');

function mapStateToProps(state) {
    const salesDate = selector(state, 'SalesDate');
    const purchaseDate = selector(state, 'PurchaseDate');
    const warehouseChosen = selector(state, 'Warehouse');

    return {
        salesDate,
        purchaseDate,
        warehouseChosen,

        todaysIncomingOrders: state.purchaseOrders.todaysIncomingOrders,
        todaysIncomingOrdersIsLoading: state.purchaseOrders.todaysIncomingOrdersIsLoading,
        todaysIncomingOrdersError: state.purchaseOrders.todaysIncomingOrdersError,

        todaysOutgoingOrders: state.salesOrders.todaysOutgoingOrders,
        todaysOutgoingOrdersIsLoading: state.salesOrders.todaysOutgoingOrdersIsLoading,
        todaysOutgoingOrdersError: state.salesOrders.todaysOutgoingOrdersError,

        salesOrders: state.warehouses.salesOrders,
        SOIsLoading: state.warehouses.salesOrdersIsLoading,
        SOError: state.warehouses.salesOrdersError,

        currentPurchaseOrder: state.purchaseOrders.currentPurchaseOrder,

        purchaseOrders: state.warehouses.purchaseOrders,
        POIsLoading: state.warehouses.purchaseOrdersIsLoading,
        POError: state.warehouses.purchaseOrdersError,

        warehouses: state.warehouses.all,
        warehousesIsLoading: state.warehouses.isLoading,
        warehousesError: state.warehouses.error,

        warehouseBinsDetail: state.warehouses.warehouseBinsDetail,
        warehouseBinsDetailIsLoading: state.warehouses.warehouseBinsDetailIsLoading,
        warehouseBinsDetailError: state.warehouses.warehouseBinsDetailError,

        inventories: state.inventories.all,
        favorites: state.favorites.all,
        inventoryIsLoading: state.inventories.isLoading,
        favoritesAreLoading: state.favorites.isLoading,
        inventoryError: state.inventories.error,
        favoritesError: state.favorites.error,
        currentInventory: state.inventories.currentInventory,
        currentFavorites: state.favorites.currentFavorites,

    };
}

export default connect(mapStateToProps, { fetchPurchaseOrders, selectPurchaseOrder, resetCurrentPurchaseOrder,
                                            fetchInventories, fetchFavorites, selectInventory, selectFavorites,
                                             resetCurrentInventory, resetCurrentFavorites, deleteFavorite,
                                               fetchWarehouses, fetchWarehouseSalesOrders, fetchWarehousePurchaseOrders,
                                                fetchWarehouseBins, fetchTodaysIncomingOrders, fetchIncomingOrdersByDate,
                                                 fetchTodaysOutgoingOrders, fetchOutgoingOrdersByDate })(warehouseDashboard);



// WEBPACK FOOTER //
// ./master/jsx/containers/Purchase/warehouseDashboard.jsx